import searchTransferOrdersRequest from './requests/searchTransferOrdersRequest';
import getTransferOrderRequest from './requests/getTransferOrderRequest';
import getNextTransferOrderNumberRequest from './requests/getNextTransferOrderNumberRequest';
import createTransferOrderRequest from './requests/createTransferOrderRequest';
import updateTransferOrderRequest from './requests/updateTransferOrderRequest';
import requestTransferOrderRequest from './requests/requestTransferOrderRequest';
import issueTransferOrderRequest from './requests/issueTransferOrderRequest';
import unissueTransferOrderRequest from './requests/unissueTransferOrderRequest';
import unrequestTransferOrderRequest from './requests/unrequestTransferOrderRequest';
import voidTransferOrderRequest from './requests/voidTransferOrderRequest';
import closeShortTransferOrderRequest from './requests/closeShortTransferOrderRequest';
import deleteTransferOrderRequest from './requests/deleteTransferOrderRequest';
import {RequestDefinitionData} from '../../components/RequestDefinition';
const transferOrdersEndpoints: RequestDefinitionData[] = [
    searchTransferOrdersRequest,
    getTransferOrderRequest,
    getNextTransferOrderNumberRequest,
    createTransferOrderRequest,
    updateTransferOrderRequest,
    requestTransferOrderRequest,
    issueTransferOrderRequest,
    unissueTransferOrderRequest,
    unrequestTransferOrderRequest,
    voidTransferOrderRequest,
    closeShortTransferOrderRequest,
    deleteTransferOrderRequest,
];

export const transferOrdersHeader = {
    title: 'Transfer Orders',
    description: 'This is an object representing a Fishbowl transfer order. Transfer orders are used ' +
        'to move inventory between location groups.',
    linkName: 'Transfer Orders',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Transfer-Order',
    endpoints: transferOrdersEndpoints,
};
